import { Placement, Strategy } from '@floating-ui/core'
import { AriaTooltipProps } from '@react-aria/tooltip'
import { TooltipTriggerState } from '@react-stately/tooltip'
import { ReactElement, ReactNode } from 'react'

export interface PopoverProps extends AriaTooltipProps {
  state: TooltipTriggerState
  label: ReactNode
  onPress?: () => void
  className?: string
  style: any
}

export interface TooltipProps {
  placement?: Placement
  strategy?: Strategy
  label: ReactNode
  mouseEnterDelay?: number
  mouseLeaveDelay?: number
  className?: string
  shiftPadding?: number
  hide?: boolean
  usePortal?: boolean
  tooltipState?: Partial<TooltipTriggerState>
  children: ReactElement
}

export type Side = 'bottom' | 'top' | 'left' | 'right'

export const StaticSidesConfig: Record<Side, Side> = {
  top: 'bottom',
  right: 'left',
  bottom: 'top',
  left: 'right',
} as const
